// extracted by mini-css-extract-plugin
module.exports = {"TabNav":"library-tab-btn_TabNav__3solS","tabBtn":"library-tab-btn_tabBtn__32xDy"};